import React from "react";
import { Box } from "@mui/material";
import MonitoringHeader from "../components/MonitoringHeader";
import DripSessionListTable from "../components/DripSessionTable";
import { getDripSessions } from "../api/dripSessionsApi";
import { prettyError } from "../utils/prettyError";

function normalizeRows(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
}

export default function DripSessionListPage() {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  const fetchRows = React.useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const data = await getDripSessions();
      setRows(normalizeRows(data));
    } catch (err) {
      setError(prettyError(err));
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchRows();
  }, [fetchRows]);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f8fafc", py: 3 }}>
      <Box sx={{ maxWidth: 1400, mx: "auto", px: 2 }}>
        <MonitoringHeader
          title="Drip Session List"
          subtitle="View all drip sessions with patient name, UID, fluid serial number, start time and status."
          onRefresh={fetchRows}
          loading={loading}
        />
        <DripSessionListTable rows={rows} loading={loading} error={error} />
      </Box>
    </Box>
  );
}